import { Link } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
export default {
  components: {
    Icon: Icon,
    Link: Link
  },
  methods: {
    isUrl: function isUrl() {
      var currentUrl = this.$page.url.substr(1);
      for (var _len = arguments.length, urls = new Array(_len), _key = 0; _key < _len; _key++) {
        urls[_key] = arguments[_key];
      }
      if (urls[0] === '') {
        return currentUrl === '';
      }
      return urls.filter(function (url) {
        return currentUrl.startsWith(url);
      }).length;
    },
    gotoReport: function gotoReport(index) {
      if (index == 'prospector_mapping') {
        window.open('https://app.funnl.ai/admin/sync_errors', '_blank');
      } else if (index == 'quality_tools') {
        window.open('https://quality.funnl.ai/login', '_blank');
      } else if (index == '/leaderboard/index') {
        window.open('/leaderboard', '_blank');
      } else {
        this.$inertia.visit(index);
      }
    },
    getPosition: function getPosition(string, subString, index) {
      return string.split(subString, index).join(subString).length;
    }
  }
};